import {Packer} from "docx";
import {saveAs} from "file-saver";
import {getFileName} from "../../helpers/filename";
// import PdfDocuments from "./pdfDocuments";
import {EinzelGutachten} from "./results/EinzelGutachten";
import {Summary} from "./summary/Summary";

class WordDocumentReact {
  static async createEinzelgutachten(user, klausur, schueler, textbausteine, companies, schuelerList) {
    console.log("inside createEinzelgutachten", arguments);
    if (!(user && klausur && schueler && textbausteine && schuelerList)) return;
    const einzelgutachten = await EinzelGutachten.create(user, klausur, schueler, textbausteine, companies);
    const fileName = getFileName(klausur, companies, schuelerList, schueler.id);
    await this.packAndCreate(einzelgutachten, `${fileName}.docx`);
    // await PdfDocuments.createFromDocx(einzelgutachten, fileName);
    return einzelgutachten;
  }

  static async createAllGutachten(user, klausur, schuelerList, textbausteine, companies) {
    const filtered = schuelerList.filter(s => !s.entwurf);
    for (let i = 0; i < filtered.length; i++) {
      const schueler = filtered[i];
      await this.createEinzelgutachten(user, klausur, schueler, textbausteine, companies, schuelerList);
    }
  }

  static async createSummary(user, klausur, schueler, companies) {
    const summary = await Summary.create(user, klausur, schueler, companies);

    const fileName = `${getFileName(klausur, companies, schueler)}__Zusammenfassung`;
    await this.packAndCreate(summary, `${fileName}.docx`);
    // await PdfDocuments.createFromDocx(summary, fileName);
    return summary;
  }

  static async packAndCreate(docxDoc, fullFileName) {
    Packer.toBlob(docxDoc).then(blob => {
      saveAs(blob, fullFileName);
    });
    return "sent";
  }
}

export default WordDocumentReact;
